import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_linked_accounts'

function LinkedAccountsI18n({ classes }: { classes: ReturnType<typeof styles> }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('intro')}
      <br />
      <br />
      {formatMessage('note')}
    </div>
  )
}

function LinkedAccounts(_props: HelpComponentProps) {
  const classes = styles()

  // Wrap in try-catch for renderToString contexts where Redux may not be available
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <LinkedAccountsI18n classes={classes} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      You can add additional email addresses you have in the same domain to forward quarantined email to this account.
      Enter the email address in the <b>Account (Email Address)</b> field, and then click <b>Add</b>.
      <br />
      <br />
      <b>Note:</b> You can only link email addresses in domains registered to your Barracuda Email Gateway Defense
      account. Check with your account administrator for a list of these domains.
    </div>
  )
}

export default LinkedAccounts
